export const ADD_TO_CART_MESSAGES_ID = 'ADD_TO_CART_MESSAGES_ID';
export const ADD_TO_CART_COMMON_MESSAGE_ID = 'ADD_TO_CART_COMMON_MESSAGE_ID';
